module.exports = __webpack_public_path__ + "static/ro-workshops-5-eeef1600fc0d9685ce8ffdfcb36d634d.jpg";